import React from 'react';
import PropTypes from 'prop-types';
import GalleryCard from './GalleryCard';
import '../styles/gallery.css';

function Gallery({ galleryData, onCardClick, folder = 'photography' }) {
  return (
    <div className="gallery">
      {galleryData.map((photo) => (
        <GalleryCard
          key={photo.id}
          photo={photo}
          onClick={onCardClick}
          folder={folder}
        />
      ))}
    </div>
  );
}

Gallery.propTypes = {
  galleryData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      imageName: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired
    })
  ).isRequired,
  onCardClick: PropTypes.func.isRequired,
  folder: PropTypes.string
};

export default Gallery;
